export const PRODUCTS_META = {
  bacWater: {
    slug: "bac-water-10ml",
    accent: "#00529B",
    chapter: "01",
  },
  tirzepatide: {
    slug: "tirzepatide-30mg",
    accent: "#D12A2F",
    chapter: "02",
  },
  retatrutide: {
    slug: "retatrutide-20mg",
    accent: "#5A2A82",
    chapter: "03",
  },
  ghk: {
    slug: "ghk-100mg",
    accent: "#007A78",
    chapter: "04",
  },
};

export const NAV = [
  { key: "shop", labelNl: "Catalogus", labelEn: "Catalogue", to: "/shop" },
  { key: "about", labelNl: "Over ons", labelEn: "About", to: "/about" },
  { key: "faq", labelNl: "Vragen", labelEn: "FAQ", to: "/faq" },
  { key: "contact", labelNl: "Contact", labelEn: "Contact", to: "/contact" },
];
